import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import ballImageDefault from "../../images/default_ball.png";

const Image = (props) => {
  const LAZY_IMAGE_PROPS = {
    onError: (event) => {
      return (event.target.src = props.placeholderSrc
        ? props.placeholderSrc
        : ballImageDefault);
    },
    effect: "blur",
  };

  return (
    <LazyLoadImage
      {...props}
      placeholder={<div style={props.style} />}
      src={
        props.src && props.src !== ""
          ? props.src
          : props.placeholderSrc && props.placeholderSrc !== ""
          ? props.placeholderSrc
          : ballImageDefault
      }
      className={
        props.src && props.src !== ""
          ? "image-loaded"
          : props.placeholderSrc && props.placeholderSrc !== ""
          ? "image-placeholder"
          : "image-default"
      }
      {...LAZY_IMAGE_PROPS}
    />
  );
};

export default Image;
